import Link from 'next/link';

import { Article } from '@/shared/components/article';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';

import { CARD_CLASS_NAME, PARTNERS } from './constants';

export const Partners = () => {
  return (
    <Article>
      <h2 className="mb-8 header-h2">Our partners and their feedback</h2>

      <section className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
        {PARTNERS.map((item, index) => (
          <Card key={index} className={CARD_CLASS_NAME}>
            {item.type === 'partner' && item.Icon && (
              <div className="relative mb-8 h-10 w-full max-w-[30%] shrink-0 md:mb-20">
                <item.Icon className="mr-auto w-[60px] xs:w-[80px] lg:w-[100px]" />
              </div>
            )}

            {item.type === 'partner' && (
              <div className="shrink-0">
                <h3 className="header-h2">Official Partner</h3>
                <p>
                  of&nbsp;
                  <Button variant="link" className="px-0 text-base">
                    <Link
                      href={item.link}
                      aria-label={`Link to ${item.partnerName} website`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-brand-accent-normal dark:text-brand-accent-light"
                    >
                      {item.partnerName}
                    </Link>
                  </Button>
                </p>
              </div>
            )}

            {item.type === 'review' && <h3 className="mb-6 shrink-0 header-h2">{item.title ?? '#NDA'}</h3>}

            <div className="mt-auto flex min-h-0 flex-col">
              <p
                className="mb-4 max-w-lg text-sm text-muted-foreground"
                dangerouslySetInnerHTML={{ __html: item.text }}
              />

              {item.type === 'review' && (
                <p className="mt-2 shrink-0 text-sm font-medium text-muted-foreground">{item.subtitle}</p>
              )}
            </div>
          </Card>
        ))}
      </section>
    </Article>
  );
};
